var defineWellKnownSymbol=require('../internals/define-well-known-symbol');// `Symbol.matchAll` well-known symbol
defineWellKnownSymbol('matchAll');